<template>
  <div id="blankHome">
  </div>
</template>
<script>

import { mapState } from "vuex";
export default {
  components: {
  },

  computed: {
    ...mapState(["FUNAPI"]),
    ...mapState(["lang"]),

  },
  data() {
    return {
    }
  },
  created() {
    console.info('/home123')
  
  },
};

</script>
<style lang="less">
 
</style>
